export default __webpack_public_path__ + "446adbe8bf6db54a95fc028b482f0ed3.png";